// extracted by mini-css-extract-plugin
export default {"link":"MenuLink_link__3y5KJ","linkDestacado":"MenuLink_linkDestacado__00-N+"};